// extracted by mini-css-extract-plugin
module.exports = {"message":"Message_message__2Q_JB","userName":"Message_userName__1FDld"};